export const onlyMobile = 'hidden-md hidden-lg hidden-xl'
export const exceptMobile = 'hidden-xs hidden-sm'
